/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import axios from "axios";
import React, { Component } from "react";
import AlertMessage from "./Alert";
import { WarningMessage } from "../Utils.js";

class News extends Component {
    constructor(props) {
        super(props);
        this.state = {
            news: [],
        };
    }

    componentDidMount() {
        axios({
            method: "get",
            url: "/api/news/",
            responseType: "json",
        })
            .then((response) => {
                this.setState({ news: response.data.results });
            })
            .catch((error) => {
                WarningMessage(error);
            });
    }

    render() {
        const { news } = this.state;

        return (
            <div
                id="main"
                className="grid md:grid-flow-col-dense sm:grid-flow-row-dense grid-cols-6 gap-4"
            >
                <section className="col-start-2 col-span-4">
                    <AlertMessage />
                    <div className="py-8 lg:py-16 px-4 mx-auto text-gray-900 dark:text-white">
                        <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-center">
                            Latest News
                        </h2>
                        <div className="mb-4 text-justify">
                            {news.length > 0 ? (
                                news.map((item, index) => (
                                    <div
                                        key={index}
                                        className="border-b-2 border-gray-300 mb-4 pb-4"
                                    >
                                        <h3 className="text-xl font-bold mb-2">
                                            {item.title}
                                        </h3>
                                        <p className="whitespace-pre-line">{item.text}</p>
                                    </div>
                                ))
                            ) : (
                                <p className="text-center text-lg">No news available.</p>
                            )}
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default News;